import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/pjb/organisms/Meta';
import { Complete } from '@bizapp-lp/pjb/templates/Complete';

type CompleteState = {
  valid?: boolean;
};

export interface CompleteContactProps {
  isAllowedDirectAccess?: boolean;
}

const title =
  'Project Board お問い合わせ完了 | 社内外でのプロジェクトを円滑に進めるためのオンラインシェア型プロジェクト進捗管理サービス';
const description =
  'Project Boardは法人向けオンラインシェア型プロジェクト進捗管理サービスです。プロジェクト管理でよく利用されるガントチャート機能やかんばん機能を搭載し、チームや組織、外部ユーザーとのコラボレーションによる業務の効率化をサポートします。';

const CompleteContact: React.FC<CompleteContactProps> = ({
  isAllowedDirectAccess = false,
}) => {
  const { state } = useLocation() as { state: CompleteState };

  return isAllowedDirectAccess || state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="お問い合わせ"
        heading2="お問い合わせが完了しました"
        description={
          <>
            <span>お問い合わせいただき、ありがとうございました。</span>
            <span>確認のためお客様へ自動返信メールをお送りしております。</span>
            <span>
              弊社担当よりご連絡いたしますので、今しばらくお待ちください。
            </span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/pjb/invalid" replace />
  );
};

export default CompleteContact;
